import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center">
          {/* Logo */}
          <div className="mb-8">
            <img
              src="https://res.cloudinary.com/ditcmszc1/image/upload/v1769763261/imperier-logo-light_bemqas_slewif.png"
              alt="Imperier Holdings"
              className="h-16 w-auto"
            />
          </div>

          {/* Contact Us Heading */}
          <h2 className="text-3xl font-bold mb-8 tracking-wide">CONTACT US</h2>

          {/* Contact Details */}
          <div className="flex flex-col items-center space-y-4 text-center">
            <a
              href="mailto:imperierholdings@gmail.com"
              className="text-lg hover:text-lightBlue transition-colors duration-200"
            >
              imperierholdings@gmail.com
            </a>
            <a
              href="mailto:yash.imperier@gmail.com"
              className="text-lg hover:text-lightBlue transition-colors duration-200"
            >
              yash.imperier@gmail.com
            </a>
            <a
              href="tel:+918840594334"
              className="text-lg hover:text-lightBlue transition-colors duration-200"
            >
              +91 88405 94334
            </a>
          </div>

          {/* Divider */}
          <div className="w-full max-w-2xl border-t border-grey/30 my-8"></div>

          {/* Copyright */}
          <p className="text-sm text-grey">
            © {new Date().getFullYear()} Imperier Holdings. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

